import { SchedulingType } from "../enums/taskType";
import { Asset } from "../models/asset";
import { Dealership } from "../models/dealership";
import { Scheduling } from "../models/schedule";
import { getGroupIdByName } from "../services/groupService";
import { AssetPlanDto } from "./assetPlanDto";
import { CheckupDto } from "./checkupDto";

export const AssetDto = (data: any): Asset => {
  // Debug: Verificar o que está chegando da API
  console.log('🔍 AssetDto - Dados completos da API:', data);
  console.log('🔍 AssetDto - data.vehicle:', data.vehicle);
  console.log('🔍 AssetDto - data.vehicle.vehicleType:', data.vehicle?.vehicleType);
  console.log('🔍 AssetDto - data.vehicle.vehicleModel:', data.vehicle?.vehicleModel);
  console.log('🔍 AssetDto - data.vehicle.name:', data.vehicle?.name);
  
  const result = {
    id: data.vehicle.assetId,
    name: data.vehicle.name,
    model: data.vehicle.vehicleModel,
    chassis: data.vehicle.chassis,
    odometer: data.vehicle.odometer,
    lastOdometerUpdate: data.vehicle.metricDates?.odometer ? new Date(data.vehicle.metricDates?.odometer) : undefined,
    hourmeter: data.vehicle.hourMeter,
    lastHourmeterUpdate: data.vehicle.metricDates?.hourMeter ? new Date(data.vehicle.metricDates?.hourMeter) : undefined,
    year: data.vehicle.vehicleYear,
    licensePlate: (data.vehicle.plate ?? data.vehicle.licensePlate) !== '-' ? (data.vehicle.plate ?? data.vehicle.licensePlate) : null,
    plans: (data.plans || data.vehiclePlan)?.map(AssetPlanDto),
    volksTotalPlan: data.volksTotal,
    score: data.vehicleScore ?? "-",
    groupName: data.vehicle.vehicleGroup,
    group: data.vehicle.vehicleGroupId ?? getGroupIdByName(data.vehicle.vehicleGroup),
    groupIds: data.groups,
    warrantyStatus: data.warrantyStatus,
    status: data.status,
    geoLocation: data.geoLocation,
    emissionStandard: data.vehicle?.emissionStandard ?? data.vehicle?.emissionStandart,
    campaigns: data.campaigns,
    accountName: data.accountName,
    type: data.vehicle.vehicleType,
    schedulings: {
      previous: data.previousCheckups
        ?.filter(Boolean)
        ?.map((checkup: any) => AssetSchedulingDto({ ...checkup, isFinished: true })),
      next: data.nextCheckups
        ?.filter(Boolean)
        ?.map((checkup: any) => AssetSchedulingDto({ ...checkup, isFinished: false })),
    }
  };
  
  console.log('🔍 AssetDto - Resultado final:', result);
  return result;
};

export const AssetSchedulingDto = (data: any): Scheduling => {
  // Criar um asset básico com os dados necessários
  const basicAsset = {
    id: data.vehicle?.assetId || '',
    name: data.vehicle?.name || '',
    model: data.vehicle?.vehicleModel || '',
    chassis: data.vehicle?.chassis || '',
    odometer: data.vehicle?.odometer || 0,
    hourmeter: data.vehicle?.hourMeter || 0,
    year: data.vehicle?.vehicleYear || 0,
    // Compatibilidade: algumas rotas retornam `plate`, outras `licensePlate`
    licensePlate: (data.vehicle?.plate ?? data.vehicle?.licensePlate) !== '-' ? (data.vehicle?.plate ?? data.vehicle?.licensePlate) : null,
    groupName: data.vehicle?.vehicleGroup || '',
    group: data.vehicle?.vehicleGroupId || '',
    type: data.vehicle?.vehicleType || '',
  };
  
  return {
    id: data.id ?? data.schedule?.id,
    scheduleNumber: data.scheduleNumber,
    checkup: CheckupDto({
      odometer: data.checkup?.range?.start ?? data.schedule?.odometer ?? null,
      hourMeter: data.schedule?.hourMeter,
      type: SchedulingType.PREVENTIVA,
      range: data?.checkup?.range ?? { 
        start: data.schedule?.odometer, end: null 
      },
      checkupType: data.checkup?.checkupType ?? data.maintenance?.checkupType,
    }),
    hourmeter: data.schedule?.hourMeter,
    odometer: data.schedule?.odometer || data.checkup?.range?.start,
    asset: basicAsset,
    driver: undefined,
    date: data.maintenance?.statusId === 'FINISHED' ?
      data.maintenance?.checkoutDate && new Date(data.maintenance?.checkoutDate) :
      data.schedule?.scheduledDate && new Date(data.schedule.scheduledDate),
    os: data.maintenance?.serviceOrder,
    isFinished: data.isFinished ?? false,
    maintenanceStatus: data.maintenance?.statusId,
    dealership: {
      id: data.maintenance?.dealershipId ?? '',
      name: data.maintenance?.dealershipName ?? '',
      address: data.maintenance?.dealershipAddress ?? '',
    }
  };
}

export const AssetSummaryDto = (data: any): Asset => {
  return {
    id: data.id,
    name: data.name,
    type: data.type,
    groupIds: data.groupIds?.length ? data.groupIds : ['ungruped'],
    chassis: data.identification,
    odometer: 0,
    hourmeter: 0,
    model: '',
    year: 0,
    licensePlate: data.license_plate,
  };
};

export const UptimeAssetDto = (data: any): Asset => {
  return {
    chassis: data.chassis,
    odometer: data.odometer,
    hourmeter: data.hourmeter,
    lastOdometerUpdate: data.lastOdometerUpdate
      ? new Date(data.lastOdometerUpdate)
      : undefined,
    lastHourmeterUpdate: data.lastHourmeterUpdate
      ? new Date(data.lastHourmeterUpdate)
      : undefined,
    id: '',
    name: '',
    model: '',
    year: 0,
    licensePlate: '',
  };
};
